import {OccFilterConfig, defaultOccFilterConfig} from '@vista/omnichannel-components-ui/lib/src/lib/context/occ/types/config/filter'

export function getFilterConfigData():OccFilterConfig {
    return {
        ...defaultOccFilterConfig,
    }
}